import { Chip } from '@material-ui/core'
import ChipInput from 'material-ui-chip-input'
import React from 'react'

import { IInputProps } from 'src/types'

const BasicArrayInput = ({
  classes,
  property,
  name,
  onChange,
  value,
}: IInputProps<string[]>): JSX.Element => {
  return (
    <ChipInput
      disabled={property.readOnly}
      value={value ?? property.defaultValue}
      onChange={chips => onChange(chips)}
      onDelete={chip => {
        onChange(value?.filter(item => item !== chip))
      }}
      chipRenderer={(
        { value, isDisabled, isReadOnly, handleClick, handleDelete, className },
        key,
      ) => (
        <Chip
          key={key}
          className={className}
          style={{
            pointerEvents: isDisabled || isReadOnly ? 'none' : undefined,
          }}
          onClick={handleClick}
          onDelete={isDisabled || isReadOnly ? undefined : handleDelete}
          label={value}
        />
      )}
      variant='outlined'
      label={property.displayedName ?? name}
      placeholder={name}
      classes={typeof classes === 'string' ? { root: classes } : undefined}
    />
  )
}

export default BasicArrayInput
